import { fetchDataPromise, fetchFilePromise } from '../../actions/index';

export const uploadFile = (resolve, reject, formData, token) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER_API_COMMON_URI + window.CONFIG.SWS_SERVER['fileUpload'] + '/upload';
  let req = new Request(requestURL, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token
    },
    body: formData
  });

  fetchDataPromise(req, 'uploadFile', resolve, reject);
}

export const getUploadFile = (resolve, reject, fileName, token) => {
  let requestURL = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER_API_COMMON_URI + window.CONFIG.SWS_SERVER['fileUpload'] + '/files/' + fileName;
  let req = new Request(requestURL, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token
    }
  });

  fetchFilePromise(req, 'getUploadFile', resolve, reject);
}

export const generateUUID = () => {
  let d = Date.now();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); //use high-precision timer if available
  }
  
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
      return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
  });
}

export const isContainWifiBand = (wifiBandStr, value) => {
  let wifiBandArr = wifiBandStr.split(",");
  return wifiBandArr.includes(value.toString());
}

export const wifiBandMapping = (wifiBandStr) => {
  let wifiBandArr = wifiBandStr.split(",");
  let newWifiBandArr = wifiBandArr.map((item) => {
      switch(item){
          case '0':
              return '2.4 GHz'
          case '1':
              return '5 GHz-1'
          case '2':
              return '5 GHz-2'
          default: 
              return '2.4 GHz'
      } 
  });

  return newWifiBandArr.join();
}

export const transferDashboardDeviceStatusType = (rowData) => {
  let newData = [];
  if (rowData !== 'No data found') {
    if (rowData['normal'] !== 0) {
      newData.push({
        'Normal': rowData['normal'],
        'name': 'Normal',
        'colorIndex': 0
      })
    } else {
      newData.push({
        'Normal': 0,
        'name': 'Normal',
        'colorIndex': 0
      })
    }
    if (rowData['alert'] !== 0) {
      newData.push({
        'Normal': rowData['alert'],
        'name': 'Alert',
        'colorIndex': 2
      })
    } else {
      newData.push({
        'Normal': 0,
        'name': 'Alert',
        'colorIndex': 2
      })
    }
    if (rowData['offline'] !== 0) {
      newData.push({
        'Normal': rowData['disconnect'],
        'name': 'Offline',
        'colorIndex': 3
      })
    } else {
      newData.push({
        'Normal': 0,
        'name': 'Offline',
        'colorIndex': 3
      })
    }
  }

  return newData;
}